import { Injectable } from '@angular/core';

type Waveform = 'sine' | 'triangle';

/**
 * Carillon du bandeau « Succès obtenu », synthétisé avec Web Audio : aucun fichier à charger, et
 * un son assez court et doux pour rester un clin d'œil.
 */
@Injectable({ providedIn: 'root' })
export class AchievementSoundService {
  private context?: AudioContext;

  play(): void {
    if (document.visibilityState !== 'visible') return;
    try {
      const Context = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
      if (!Context) return;
      this.context ??= new Context();
      const ctx = this.context;
      // Sans geste préalable de l'utilisateur, le navigateur refuse la reprise : le son se tait, le bandeau reste.
      if (ctx.state === 'suspended') void ctx.resume().catch(() => undefined);

      const start = ctx.currentTime + 0.02;
      const master = ctx.createGain();
      master.gain.value = 0.12;
      master.connect(ctx.destination);
      // Deux notes montantes (mi, si), posées sur un mi grave très discret.
      this.note(ctx, master, 659.25, start, 0.45, 'sine', 0.8);
      this.note(ctx, master, 987.77, start + 0.1, 0.75, 'sine', 1);
      this.note(ctx, master, 329.63, start, 0.6, 'triangle', 0.25);
    } catch {
      // Audio indisponible : le bandeau suffit.
    }
  }

  private note(ctx: AudioContext, output: AudioNode, frequency: number, at: number, length: number, type: Waveform, level: number): void {
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    oscillator.type = type;
    oscillator.frequency.setValueAtTime(frequency, at);
    gain.gain.setValueAtTime(0.0001, at);
    gain.gain.exponentialRampToValueAtTime(level, at + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, at + length);
    oscillator.connect(gain).connect(output);
    oscillator.start(at);
    oscillator.stop(at + length + 0.05);
  }
}
